import { CreatePayout, CreatePayroll } from "../../pages";
import { PayoutController, PayrollController } from "../../controllers";
import { MimaToastUtil } from "../../components";
import constant from "../../utils/constant";
import React, { useState } from "react";
import { observer } from "mobx-react";
import { object, string, number } from "yup";

const CreatePayoutContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async (payload) => {
    setLoading(true);

    const { status, errorMessage } =
      await PayoutController.createPayout(payload);
    setLoading(false);
    if (status === constant.Success) {
      MimaToastUtil.success({
        message: constant.Success,
      });
      return closeModal();
    }
    MimaToastUtil.error({
      message: errorMessage,
    });
  };

  const validationSchema = () => {
    return object({
      month: number().required("Month is required"),
      year: string().required("Year is required"),
    });
  };

  return (
    <CreatePayout
      closeModal={closeModal}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      loading={loading}
    />
  );
};

export default observer(CreatePayoutContainer);
